import { render, staticRenderFns } from "./OM.vue?vue&type=template&id=0c609113&scoped=true"
import script from "./OM.vue?vue&type=script&lang=js"
export * from "./OM.vue?vue&type=script&lang=js"
import style0 from "./OM.vue?vue&type=style&index=0&id=0c609113&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c609113",
  null
  
)

export default component.exports